const normalise = (name: string | null | undefined): string =>
  (name ?? "").trim().replace(/\s+/g, " ").toLowerCase();

/**
 * The DICOM `OperatorsName` is typed by hand at the scanner and routinely
 * repeats the performer, so showing both reads as two different people having
 * scanned the patient.
 */
export const resolveScannedByName = (
  performerName: string | null | undefined,
  operatorName: string | null | undefined,
): string | null => {
  const operator = (operatorName ?? "").trim();
  if (!operator) return null;
  return normalise(performerName) === normalise(operator) ? null : operator;
};
